<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-upload-visit-point-list" class="page-upload-visit-point-list">
		<section class="flex justify-between items-center">
			<div class="vx-row">
				<div class="vx-col sm:wfull w-full">
					<span style="font-size: 1em; font-weight: 400" class="font-bold">{{
						$t("AllowedVehicleFiles") + " = "
					}}</span>
					<span class="mr-8 font-bold text-l">{{ getCheckedUploadFile.length + " / " + 2 }}</span>
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col sm:wfull w-full">
					<div class="flex justify-between items-center">
						<vs-button
							class="ml-2"
							color="primary"
							type="border"
							icon-pack="feather"
							:title="maximize ? $t('Minimize') : $t('Maximize')"
							:icon="!maximize ? 'icon-map' : 'icon-minimize'"
							@click.prevent="$emit('handleMaximizeUploadFile')"
						></vs-button>
					</div>
				</div>
			</div>
		</section>
		<!-- AgGrid Table -->
		<ag-grid-vue
			ref="agGridTable"
			class="ag-theme-material w-100 my-4 ag-grid-table"
			:class="[isHeightMedium ? 'table-height' : '', {'ag-customizer-container': !isWidthPortatil}]"
			:components="components"
			:gridOptions="gridOptions"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="usersData"
			:rowSelection="customConfig.rowSelection"
			colResizeDefault="shift"
			:animateRows="true"
			:pagination="true"
			:paginationPageSize="20"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="overlayNoRowsTemplate"
			:overlayLoadingTemplate="overlayLoadingTemplate"
			:tooltipShowDelay="tooltipShowDelay"
			:enableCellTextSelection="true"
			@rowSelected="rowSelected"
		></ag-grid-vue>
	</div>
</template>

<script>
import {uploadVehicleList} from "@/components/optimization/upload-file/model/UploadVehicleListMixin.js";

export default {
	mixins: [uploadVehicleList],
};
</script>

<style lang="scss">
:root {
	--vs-dropdown-z-index: 10000;
}
#page-visit-point-list .vx-card .vx-card__header {
	padding: 0 !important;
}
#search-data .tags-input-wrapper-default {
	overflow-y: scroll;
	height: 60px;
	resize: none;
}
</style>
<style lang="scss" scoped>
.table-height {
	height: 520px !important;
}
</style>
